import { Footer } from 'remote-com-shared/components/Footer';
import HeroContext, { useHeroIntersection } from 'remote-com-shared/components/Hero/context';

import { PaidMarketingBanner } from '@/src/components/Banner/PaidMarketingBanner';
import { hasBanner } from '@/src/components/Banner/helpers';
import { transformProperties } from '@/src/domains/prismic/helpers';

export const PaidMarketingLandingLayout = ({
  paidMarketingBannerProps,
  sharedServices,
  children,
}) => {
  const heroIntersection = useHeroIntersection();
  const { footerNavigationSitewide } = sharedServices ?? {};
  const bannerProps = transformProperties(paidMarketingBannerProps?.primary);
  const { hasPaidMarketingBanner, description } = bannerProps ?? {};

  return (
    <HeroContext.Provider value={heroIntersection}>
      {hasPaidMarketingBanner && hasBanner(description) ? (
        <PaidMarketingBanner {...bannerProps} />
      ) : null}
      {children}
      <Footer {...footerNavigationSitewide} />
    </HeroContext.Provider>
  );
};
